import React, { Component } from 'react'
import '../Common.scss';
import defaultImage from '../../../assets/default.png';

export default class ElevationShutterExtension extends Component<any,any> {
  render() {
    const { pageDetails } = this.props;
    const { elevationImage} = pageDetails;
    console.log(pageDetails);
    return (
     <React.Fragment>
          <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}` :defaultImage} alt="" className="image-view" />
                    </div>
           </div>
     </React.Fragment>
    )
  }
}